import { useLocation } from 'react-router-dom';
import {
  SortMenuOption,
  SortOptions,
} from 'src/components/subHeader/SubHeaderWithSorting.interface';
import {
  useGetAllLayoutType,
  useGetPaginatedLocationGroupsList,
  useParamQuery,
} from 'src/hooks';
import { formatQuery } from 'src/utils';

export const useLocationGroupTab = (filter?: string) => {
  const { onChangeParams, getParamsValue, activeFilters } = useParamQuery({
    sort: ['name'],
    page: ['1'],
  });
  const location = useLocation();
  const pageParam = Number(getParamsValue('page')?.[0] || 1);
  const page = Number.isInteger(pageParam) && pageParam > 0 ? pageParam : 1;

  const { data, isLoading: isLoadingLocationGroups } =
    useGetPaginatedLocationGroupsList(
      formatQuery(location.search + (filter ?? '')),
    );

  const { data: layoutTypes = [], isLoading: isLoadingLayoutTypes } =
    useGetAllLayoutType();

  const locationGroups =
    data?.locationGroups?.map((group) => ({
      ...group,
      layoutType: layoutTypes.find((type) => type.id === group.layout_type_id)
        ?.name,
    })) ?? [];
  const totalPages = data?.totalPages ?? 0;
  const totalCount = data?.totalCount ?? 0;

  const handlePageChange = (
    _event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    onChangeParams('page', [`${value}`]);
  };

  const selectedSortOption: SortMenuOption = {
    option: getParamsValue('sort')[0]?.replace('-', '') as SortOptions,
    order: getParamsValue('sort')[0]?.includes('-') ? 'desc' : 'asc',
  };

  const onSortChangeHandle = (selectedOption: {
    option: SortOptions;
    order: 'desc' | 'asc';
  }) => {
    onChangeParams('sort', [
      `${selectedOption.order === 'desc' ? '-' : ''}${selectedOption.option}`,
    ]);
  };

  return {
    locationGroups,
    onChangeParams,
    isLoadingLayoutTypes,
    isLoadingLocationGroups,
    selectedSortOption,
    onSortChangeHandle,
    layoutTypes,
    totalCount,
    totalPages,
    page,
    handlePageChange,
    activeFilters,
  };
};
